
(function () {
  function initSection(root) {
    if (!root || root.dataset.z9pInit === '1') return;
    root.dataset.z9pInit = '1';

    var sectionId = root.dataset.sectionId || '';
    var productDataEl = root.querySelector('[data-z9p-product-json]');
    if (!productDataEl) return;
    var product;
    try { product = JSON.parse(productDataEl.textContent); }
    catch (e) { return; }
    if (!product || !product.variants || !product.variants.length) return;

    
    var variantMediaMap = {};
    var variantMediaEl = root.querySelector('[data-z9p-variant-media-map]');
    if (variantMediaEl) {
      try { variantMediaMap = JSON.parse(variantMediaEl.textContent); } catch (e) {  }
    }

    
    var splitShippingMap = {};
    var splitJsonEl = root.querySelector('[data-z9p-split-shipping-json]');
    if (splitJsonEl) {
      try { splitShippingMap = JSON.parse(splitJsonEl.textContent); } catch (e) {  }
    }

    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';

    function formatMoney(cents) {
      if (cents === null || cents === undefined) return '';
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var formatted = parts.join('.');
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/g, formatted)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, parts[0])
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, formatted.replace('.', ','));
    }

    
    var slides = root.querySelectorAll('.pdp-slide');
    var thumbs = root.querySelectorAll('.pdp-thumb');
    var dotsWrap = root.querySelector('[data-z9p-dots]');
    var prevBtn = root.querySelector('[data-z9p-prev]');
    var nextBtn = root.querySelector('[data-z9p-next]');
    var currentSlide = 0;
    var totalSlides = slides.length;

    
    if (dotsWrap && totalSlides > 1) {
      dotsWrap.innerHTML = '';
      for (var d = 0; d < totalSlides; d++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pdp-slider-dot' + (d === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (d + 1));
        (function (idx) { dot.addEventListener('click', function () { goToSlide(idx); }); })(d);
        dotsWrap.appendChild(dot);
      }
    }

    function goToSlide(index) {
      if (totalSlides === 0) return;
      index = ((index % totalSlides) + totalSlides) % totalSlides;
      if (slides[currentSlide]) slides[currentSlide].classList.remove('active');
      if (thumbs[currentSlide]) thumbs[currentSlide].classList.remove('active');
      var dots = dotsWrap ? dotsWrap.querySelectorAll('.pdp-slider-dot') : [];
      if (dots[currentSlide]) dots[currentSlide].classList.remove('active');

      currentSlide = index;
      if (slides[currentSlide]) slides[currentSlide].classList.add('active');
      if (thumbs[currentSlide]) thumbs[currentSlide].classList.add('active');
      if (dots[currentSlide]) dots[currentSlide].classList.add('active');

      
      scrollThumbIntoView(currentSlide);
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { goToSlide(i); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { goToSlide(currentSlide - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goToSlide(currentSlide + 1); });

    
    var sliderEl = root.querySelector('.pdp-slider');
    if (sliderEl && totalSlides > 1) {
      var startX = 0;
      sliderEl.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      sliderEl.addEventListener('touchend', function (e) {
        var diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) goToSlide(diff > 0 ? currentSlide + 1 : currentSlide - 1);
      });
    }

    
    var thumbStrip = root.querySelector('[data-z9p-thumb-strip]');
    var thumbTrack = root.querySelector('[data-z9p-thumb-track]');
    var thumbPrev = root.querySelector('[data-z9p-thumb-prev]');
    var thumbNext = root.querySelector('[data-z9p-thumb-next]');
    var thumbOffset = 0;

    function getThumbItemWidth() {
      if (!thumbs.length) return 94;
      var first = thumbs[0];
      return first.offsetWidth + 10; 
    }

    function getMaxThumbOffset() {
      if (!thumbStrip || !thumbTrack) return 0;
      var stripW = thumbStrip.scrollWidth;
      var trackW = thumbTrack.offsetWidth;
      return Math.max(0, stripW - trackW);
    }

    function setThumbOffset(px) {
      var max = getMaxThumbOffset();
      thumbOffset = Math.max(0, Math.min(px, max));
      if (thumbStrip) thumbStrip.style.transform = 'translateX(-' + thumbOffset + 'px)';
      if (thumbPrev) thumbPrev.disabled = thumbOffset <= 0;
      if (thumbNext) thumbNext.disabled = thumbOffset >= max;
    }

    function scrollThumbIntoView(idx) {
      if (!thumbTrack || !thumbs[idx]) return;
      var itemW = getThumbItemWidth();
      var trackW = thumbTrack.offsetWidth;
      var itemLeft = idx * itemW;
      var itemRight = itemLeft + itemW;

      if (itemLeft < thumbOffset) {
        setThumbOffset(itemLeft);
      } else if (itemRight > thumbOffset + trackW) {
        setThumbOffset(itemRight - trackW);
      }
    }

    if (thumbPrev) thumbPrev.addEventListener('click', function () {
      setThumbOffset(thumbOffset - getThumbItemWidth() * 3);
    });
    if (thumbNext) thumbNext.addEventListener('click', function () {
      setThumbOffset(thumbOffset + getThumbItemWidth() * 3);
    });

    
    setTimeout(function () { setThumbOffset(0); }, 50);

    
    var isDesktop = window.matchMedia('(min-width: 990px)');

    root.querySelectorAll('.pdp-zoom-wrap').forEach(function (wrap) {
      var img = wrap.querySelector('img');
      if (!img) return;

      wrap.addEventListener('mouseenter', function () {
        if (!isDesktop.matches) return;
        wrap.classList.add('is-zooming');
      });

      wrap.addEventListener('mousemove', function (e) {
        if (!isDesktop.matches || !wrap.classList.contains('is-zooming')) return;
        var rect = wrap.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
      });

      wrap.addEventListener('mouseleave', function () {
        wrap.classList.remove('is-zooming');
        img.style.transformOrigin = 'center center';
      });
    });

    
    var optionGroups = root.querySelectorAll('[data-z9p-option-group]');
    var selectedOptions = [];
    var optionCount = product.options.length;
    for (var i = 0; i < optionCount; i++) selectedOptions[i] = null;

    var variantIdInput = root.querySelector('[data-z9p-variant-id]');
    var priceEl = root.querySelector('[data-z9p-price]');
    var priceCompareEl = root.querySelector('[data-z9p-price-compare]');
    var priceSaveEl = root.querySelector('[data-z9p-price-save]');
    var skuEl = root.querySelector('[data-z9p-sku]');
    var stockEl = root.querySelector('[data-z9p-stock]');
    var stockLabel = stockEl ? stockEl.querySelector('[data-z9p-stock-label]') : null;
    var addBtn = root.querySelector('[data-z9p-add]');
    var addLabelEl = root.querySelector('.z9p-add-label');
    var installmentVal = root.querySelector('[data-z9p-installment-val]');
    var splitShipWrap = root.querySelector('[data-z9p-split-shipping]');
    var splitShipText = root.querySelector('[data-z9p-split-shipping-text]');
    var splitShipInput = root.querySelector('[data-z9p-split-prop]');
    var stickyThumb = document.querySelector('[data-z9p-sticky-thumb]');
    var stickyPrice = document.querySelector('[data-z9p-sticky-price]');
    var stickyBtn = document.querySelector('[data-z9p-sticky-add]');

    
    var urlParams = new URLSearchParams(window.location.search);
    var urlVariantId = urlParams.get('variant');
    var initialVariant = null;
    if (urlVariantId) {
      initialVariant = product.variants.find(function (v) { return String(v.id) === urlVariantId; });
    }
    if (!initialVariant) {
      initialVariant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    }
    if (initialVariant) {
      selectedOptions[0] = initialVariant.option1 || null;
      selectedOptions[1] = initialVariant.option2 || null;
      selectedOptions[2] = initialVariant.option3 || null;
      
      optionGroups.forEach(function (group) {
        var pos = parseInt(group.dataset.z9pOptionGroup, 10);
        var btns = group.querySelectorAll('[data-z9p-option-value]');
        var sel = group.querySelector('[data-z9p-opt-select]');
        btns.forEach(function (b) { b.classList.remove('active'); });
        btns.forEach(function (btn) {
          if (btn.dataset.z9pOptionValue === selectedOptions[pos - 1]) {
            btn.classList.add('active');
          }
        });
        if (sel && selectedOptions[pos - 1]) {
          sel.value = selectedOptions[pos - 1];
        }
      });
    }

    function findVariant() {
      return product.variants.find(function (v) {
        return (optionCount < 1 || v.option1 === selectedOptions[0])
            && (optionCount < 2 || v.option2 === selectedOptions[1])
            && (optionCount < 3 || v.option3 === selectedOptions[2]);
      });
    }

    function updateOptionAvailability() {
      optionGroups.forEach(function (group) {
        var pos = parseInt(group.dataset.z9pOptionGroup, 10);
        var btns = group.querySelectorAll('[data-z9p-option-value]');
        btns.forEach(function (btn) {
          var test = selectedOptions.slice();
          test[pos - 1] = btn.dataset.z9pOptionValue;
          var possible = product.variants.some(function (v) {
            return v.available
              && (optionCount < 1 || v.option1 === test[0] || test[0] === null)
              && (optionCount < 2 || v.option2 === test[1] || test[1] === null)
              && (optionCount < 3 || v.option3 === test[2] || test[2] === null);
          });
          btn.classList.toggle('is-unavailable', !possible);
        });
      });
    }

    function renderSelectedLabel(group, value) {
      var el = group.querySelector('[data-z9p-option-selected]');
      if (el) el.textContent = value || '';
    }

    function updateVariant() {
      var variant = findVariant();

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; }
        if (addLabelEl) addLabelEl.textContent = 'Unavailable';
        if (stockEl) { stockEl.classList.add('is-out'); if (stockLabel) stockLabel.textContent = 'Unavailable'; }
        if (stickyBtn) { stickyBtn.disabled = true; }
        updateOptionAvailability();
        return;
      }

      if (variantIdInput) variantIdInput.value = variant.id;

      
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (priceCompareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceCompareEl.textContent = formatMoney(variant.compare_at_price);
          priceCompareEl.hidden = false;
        } else {
          priceCompareEl.hidden = true;
        }
      }
      if (priceSaveEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          var save = variant.compare_at_price - variant.price;
          priceSaveEl.textContent = 'Save ' + formatMoney(save);
          priceSaveEl.hidden = false;
        } else {
          priceSaveEl.hidden = true;
        }
      }

      
      if (installmentVal) {
        installmentVal.textContent = '$' + (variant.price / 400).toFixed(2);
      }

      
      if (skuEl) skuEl.textContent = variant.sku || '—';

      
      if (stockEl && stockLabel) {
        var inText = stockEl.dataset.inStockText || 'In stock — ships in 1–2 business days';
        var outText = stockEl.dataset.outStockText || 'Sold out';
        if (variant.available) {
          stockEl.classList.remove('is-out');
          stockLabel.textContent = inText;
        } else {
          stockEl.classList.add('is-out');
          stockLabel.textContent = outText;
        }
      }

      
      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addLabelEl) {
          var addText = addBtn.dataset.addLabel || 'Add to Cart';
          var soldText = addBtn.dataset.soldLabel || 'Sold Out';
          addLabelEl.textContent = variant.available ? addText : soldText;
        }
      }

      
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      if (stickyBtn) stickyBtn.disabled = !variant.available;
      if (stickyThumb && variant.featured_image && variant.featured_image.src) {
        stickyThumb.src = variant.featured_image.src;
      }

      
      var targetMediaId = variantMediaMap[String(variant.id)];
      if (targetMediaId) {
        for (var si = 0; si < slides.length; si++) {
          if (parseInt(slides[si].dataset.mediaId, 10) === targetMediaId) {
            goToSlide(si);
            break;
          }
        }
      }

      
      optionGroups.forEach(function (group) {
        var pos = parseInt(group.dataset.z9pOptionGroup, 10);
        renderSelectedLabel(group, selectedOptions[pos - 1]);
      });

      
      var splitText = splitShippingMap[String(variant.id)] || '';
      
      if (typeof splitText !== 'string') splitText = '';
      if (splitShipWrap) {
        if (splitText) {
          splitShipWrap.classList.remove('hide');
          splitShipWrap.removeAttribute('hidden');
          if (splitShipText) splitShipText.textContent = splitText;
        } else {
          splitShipWrap.classList.add('hide');
          splitShipWrap.setAttribute('hidden', '');
          if (splitShipText) splitShipText.textContent = '';
        }
      }
      if (splitShipInput) {
        if (splitText) {
          splitShipInput.value = splitText;
          splitShipInput.disabled = false;
        } else {
          splitShipInput.value = '';
          splitShipInput.disabled = true;
        }
      }
      
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      updateOptionAvailability();
    }

    
    optionGroups.forEach(function (group) {
      var pos = parseInt(group.dataset.z9pOptionGroup, 10);

      
      var btns = group.querySelectorAll('[data-z9p-option-value]');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          
          btns.forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          selectedOptions[pos - 1] = btn.dataset.z9pOptionValue;
          updateVariant();
        });
      });

      
      var sel = group.querySelector('[data-z9p-opt-select]');
      if (sel) {
        sel.addEventListener('change', function () {
          selectedOptions[pos - 1] = sel.value;
          updateVariant();
        });
      }
    });

    
    updateVariant();

    
    var qtyEl = root.querySelector('[data-z9p-qty]');
    var qtyInput = root.querySelector('[data-z9p-qty-input]');
    var qtyMinus = root.querySelector('[data-z9p-qty-minus]');
    var qtyPlus = root.querySelector('[data-z9p-qty-plus]');
    var qty = 1;

    function setQty(n) {
      qty = Math.max(1, Math.min(99, n));
      if (qtyEl) qtyEl.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
    }
    if (qtyMinus) qtyMinus.addEventListener('click', function () { setQty(qty - 1); });
    if (qtyPlus) qtyPlus.addEventListener('click', function () { setQty(qty + 1); });

    
    function doAdd(btn, labelEl) {
      if (!btn || btn.disabled) return;
      var variant = findVariant();
      if (!variant || !variant.available) return;

      var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      btn.classList.add('is-loading');
      btn.disabled = true;

      var cartItem = { id: variant.id, quantity: qty };

      var splitText = splitShippingMap[String(variant.id)] || '';
      if (typeof splitText === 'string' && splitText) {
        cartItem.properties = { 'Split Shipping': splitText };
      }

      if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
        cartItem.sections = cartEl.getSectionsToRender().map(function (s) { return s.id; }).join(',');
        cartItem.sections_url = window.location.pathname;
        cartEl.setActiveElement(document.activeElement);
      }

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(cartItem)
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        btn.classList.remove('is-loading');

        if (data.status && data.status !== 200) {
          btn.disabled = false;
          window.alert(data.description || 'Could not add to cart.');
          return;
        }

        btn.classList.add('is-success');
        if (labelEl) labelEl.textContent = 'Added to Cart!';

        setTimeout(function () {
          btn.classList.remove('is-success');
          btn.disabled = false;
          if (labelEl) labelEl.textContent = addBtn.dataset.addLabel || 'Add to Cart';
        }, 2000);

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'z9-pdp-hero',
            productVariantId: String(variant.id),
            cartData: data
          });
        }

        if (cartEl && typeof cartEl.renderContents === 'function') {
          cartEl.renderContents(data);
          if (cartEl.classList.contains('is-empty')) cartEl.classList.remove('is-empty');
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        window.alert('Network error. Please try again.');
      });
    }

    if (addBtn) addBtn.addEventListener('click', function () { doAdd(addBtn, addLabelEl); });

    
    var stickyBar = document.getElementById('pdp-sticky-bar-' + sectionId);
    var stickyAddBtn = stickyBar ? stickyBar.querySelector('[data-z9p-sticky-add]') : null;

    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function () { doAdd(addBtn, addLabelEl); });
    }

    if (stickyBar && 'IntersectionObserver' in window) {
      var stickyObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting;
          stickyBar.classList.toggle('is-visible', show);
        });
      }, { rootMargin: '0px 0px 0px 0px', threshold: 0 });
      stickyObs.observe(root);
    }
  }

  
  function init() {
    document.querySelectorAll('[data-z9p-hero]').forEach(initSection);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-z9p-hero]').forEach(function (el) {
      el.dataset.z9pInit = '';
    });
    init();
  });
})();
